import TransactionRow from "./TransactionRow";
import "../../styles/table.css";

export default function TransactionTable({ transactions, onView }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Utilisateur</th>
            <th>Montant</th>
            <th>Description</th>
            <th>Type</th>
            <th className="center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {transactions.length > 0 ? (
            transactions.map((transaction) => (
              <TransactionRow
                key={transaction.id}
                transaction={transaction}
                onView={onView}
              />
            ))
          ) : (
            <tr>
              <td colSpan="5" className="emptyTable">Aucune transaction trouvée</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}